<template>
  <div style="display: inline-block">
    <v-card v-if="!loadingAgentGroup && !loadingAgentSubGroup">
      <v-card-title>
        <v-layout wrap align-center>
          <v-flex xs6>
            <div>{{ type == 'add' ? 'Add' : 'Edit' }} Ticket</div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn v-if="showCloseButton" icon small color="grey" @click="$emit('onClose')">
              <v-icon small>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <div v-if="type == 'edit' && ticket" style="font-weight: bold">
          Ticket ID:
          <CopyButtonVue :text="ticket.id">
            {{ ticket.id }}<v-icon small class="ml-1">file_copy</v-icon>
          </CopyButtonVue>
        </div>
        <div v-if="type == 'add'" class="text-xs-right">
          <v-autocomplete
            v-model="select"
            single-line
            return-object
            label="Find customer"
            solo
            :loading="loading"
            :items="items"
            :search-input.sync="search"
            outline
            prepend-inner-icon="search"
            :item-text="'first_name'"
            :item-value="'id'"
            class="default-input"
            @change="onChangeSelect"
          >
            <template #item="data">
              <template v-if="checkObject(data.item)">
                <v-list-tile-content>
                  {{ data.item }}
                </v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <img v-if="data.item.profile_pic" :src="data.item.profile_pic" />
                  <img v-else :src="'/static/img/assets/livechat/profile.png'" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ `${data.item.first_name} ${data.item.last_name}` }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>{{ data.item.app }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>

            <template #append-outer>
              <v-icon :key="`icon-delete`" :disabled="!select" @click="onClearCustomer">
                delete
              </v-icon>
            </template>
          </v-autocomplete>
        </div>
        <v-layout wrap>
          <template v-if="!livechat">
            <v-flex
              xs12
              sm6
              class="form-control px-1"
              :class="{ 'has-error': errors.has('firstname') }"
            >
              <div class="caption mb-1 mt-2">Customer First Name *</div>
              <input
                v-model="ticket.contact_firstname"
                v-validate="'required'"
                type="text"
                :placeholder="$t('customer first name')"
                class="form-control"
                maxlength="255"
                :data-vv-as="$t('Customer First Name')"
                name="firstname"
              />
              <p v-if="errors.has('firstname')" class="text-error">
                {{ errors.first('firstname') }}
              </p>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Customer Last Name</div>

              <input
                v-model="ticket.contact_lastname"
                type="text"
                :placeholder="$t('customer last name')"
                class="form-control"
                maxlength="255"
              />
            </v-flex>

            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Email</div>
              <input
                v-model="ticket.contact_email"
                type="text"
                :placeholder="$t('Email')"
                class="form-control"
                maxlength="255"
              />
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Phone No</div>
              <input
                v-model="ticket.contact_phone"
                type="number"
                :placeholder="$t('Phone No')"
                class="form-control"
                maxlength="255"
              />
            </v-flex>

            <v-flex xs12>
              <v-divider class="my-3" />
            </v-flex>
          </template>
          <template v-if="type == 'add'">
            <v-flex
              xs12
              sm6
              class="form-control px-1 pb-2"
              :class="{ 'has-error': errors.has('group') }"
            >
              <div class="caption mb-1 mt-2">Group</div>

              <v-autocomplete
                v-model="ticket.assigngroupid"
                :return-object="false"
                name="group"
                :loading="loading"
                :items="agentGroup"
                outline
                clearable
                :item-text="'groupname'"
                :item-value="'id'"
                class="default-input"
                single-line
                :hide-details="!errors.has('group')"
                :error="errors.has('group')"
                :error-messages="errors.first('group')"
                placeholder="Group"
                @change="onChangeGroup"
              />
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1 pb-2">
              <div class="caption mb-1 mt-2">Subgroup</div>
              <v-autocomplete
                :key="`subgroup-${autocompleteTimestamp}`"
                v-model="ticket.assignsubgroupid"
                single-line
                :return-object="false"
                name="subgroup"
                :loading="loading"
                :items="filterSubGroup"
                outline
                clearable
                :item-text="'subgroupname'"
                :item-value="'id'"
                class="default-input"
                :hide-details="!errors.has('subgroup')"
                :error="errors.has('subgroup')"
                :error-messages="errors.first('subgroup')"
                placeholder="Sub Group"
                @change="onChangeSubGroup"
              />
            </v-flex>
            <v-flex xs12 sm12 class="form-control px-1 pb-2 has-error">
              <div class="caption mb-1 mt-2">Assigned to&nbsp;*</div>
              <v-autocomplete
                :key="`adminid-${autocompleteTimestamp}`"
                v-model="ticket.assignadminid"
                single-line
                :return-object="false"
                name="assignedTo"
                :loading="loading"
                :items="filterAgents"
                outline
                clearable
                :item-text="'adminid'"
                :item-value="'adminid'"
                class="default-input"
                :hide-details="!errors.has('assignedTo')"
                :error="errors.has('assignedTo')"
                :error-messages="errors.first('assignedTo')"
                placeholder="Assigned to"
              />
            </v-flex>
          </template>
          <template v-else>
            <v-flex xs12 sm6 class="form-control px-1 pb-2">
              <div class="caption mb-1 mt-2">Group</div>
              <v-autocomplete
                v-model="ticket.assigngroupid"
                :return-object="false"
                name="group"
                :loading="loading"
                :items="agentGroup"
                outline
                clearable
                :item-text="'groupname'"
                :item-value="'id'"
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('group')"
                :error="errors.has('group')"
                :error-messages="errors.first('group')"
                placeholder="Group"
                @change="onChangeGroup"
              />
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1 pb-2">
              <div class="caption mb-1 mt-2">Subgroup</div>
              <v-autocomplete
                :key="`subgroup-${autocompleteTimestamp}`"
                v-model="ticket.assignsubgroupid"
                return-object
                name="subgroup"
                :loading="loading"
                :items="filterSubGroup"
                outline
                clearable
                :item-text="'subgroupname'"
                :item-value="'id'"
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('subgroup')"
                :error="errors.has('subgroup')"
                :error-messages="errors.first('subgroup')"
                placeholder="Sub Group"
                @change="onChangeSubGroup"
              />
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1 pb-2">
              <div class="caption mb-1 mt-2">
                Assigned to
                <template
                  v-if="
                    ['closed', 'closed without survey', 'closed with survey'].includes(
                      ticket.status
                    )
                  "
                  >*</template
                >
              </div>
              <v-autocomplete
                :key="`adminid-${autocompleteTimestamp}`"
                v-model="ticket.assignadminid"
                v-validate="'required_if:status,closed,closed without survey,closed with survey'"
                :return-object="false"
                name="assignedTo"
                :loading="loading"
                :items="filterAgents"
                outline
                clearable
                :item-text="(item) => (item.display_name ? item.display_name : item.adminid)"
                :item-value="'adminid'"
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('assignedTo')"
                :error="errors.has('assignedTo')"
                :error-messages="errors.first('assignedTo')"
                placeholder="Assigned to"
                :disabled="disabledAssignAdmin"
              />
            </v-flex>
          </template>

          <v-flex xs12 class="form-control px-1" :class="{ 'has-error': errors.has('subject') }">
            <div class="caption mb-1 mt-2">Subject *</div>
            <input
              v-model="ticket.subject"
              v-validate="'required'"
              type="text"
              :placeholder="$t('Subject')"
              class="form-control"
              maxlength="255"
              :data-vv-as="$t('Subject')"
              name="subject"
            />
            <p v-if="errors.has('subject')" class="text-error">{{ errors.first('subject') }}</p>
          </v-flex>
          <v-flex xs12 class="form-control px-1" :class="{ 'has-error': errors.has('details') }">
            <div class="caption mb-1 mt-2">Details *</div>
            <textarea
              id="details"
              v-model="ticket.details"
              v-validate="'required'"
              name="details"
              style="width: 100%; min-height: 100px"
              :data-vv-as="$t('Details')"
              class="form-control"
              :placeholder="$t('Details')"
            ></textarea>
            <p v-if="errors.has('details')" class="text-error">{{ errors.first('details') }}</p>
          </v-flex>

          <v-flex xs12 sm6>
            <div class="caption mb-1 mt-2">Priority</div>
            <v-autocomplete
              v-model="ticket.priority"
              :return-object="false"
              name="priority"
              :loading="loading"
              :items="priorityOptions"
              outline
              clearable
              :item-text="'label'"
              :item-value="'value'"
              class="default-input-textfield"
              single-line
              :hide-details="!errors.has('priority')"
              :error="errors.has('priority')"
              :error-messages="errors.first('priority')"
              placeholder="Priority"
            />
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control px-1 pb-2"
            :class="{ 'has-error': errors.has('status') }"
          >
            <div class="caption mb-1 mt-2">Status *</div>
            <v-autocomplete
              ref="status"
              v-model="ticket.status"
              v-validate="'required'"
              name="status"
              :loading="loading"
              :items="statusOptions"
              :return-object="false"
              item-text="label"
              item-value="value"
              outline
              clearable
              class="default-input-textfield"
              single-line
              :hide-details="!errors.has('status')"
              :error="errors.has('status')"
              :error-messages="errors.first('status')"
              placeholder="Status"
            />
          </v-flex>

          <!-- Customer Support Service -->
          <template
            v-if="
              isShowCustomerSupportServiceSurvey &&
              ticket.status &&
              ['closed with survey'].includes(ticket.status)
            "
          >
            <v-flex xs12>
              <v-layout align-center fill-height wrap>
                <v-flex class="py-2 px-1 primary--text" style="font-size: 14px"
                  >{{ $t('customer_support_service.confirm_send_survey') }}*</v-flex
                >
                <template v-if="!ticket.closed_with_survey_message">
                  <v-flex
                    v-for="(survey, index) in surveyList"
                    :key="`survey_${index}`"
                    xs12
                    class="mb-3"
                  >
                    <SurveyCard
                      :is-active="handleCheckEqual(survey, closed_with_survey_message)"
                      :message="survey.message"
                      :button-name="survey.button_name"
                      :survey-id="survey.survey_id"
                      :survey-name="survey.survey_name"
                      :created-at="survey.created_at"
                      :updated-at="survey.updated_at"
                      :is-default="survey.is_default"
                      :expired-at="survey.expire_survey_timestamp"
                      @click="handleSelectSurvey(index)"
                      @edit="(payload) => handleEditSurvey(payload, index)"
                    />
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12>
                    <SurveyCard
                      :is-disabled="true"
                      :is-active="true"
                      :message="ticket.closed_with_survey_message.message"
                      :button-name="ticket.closed_with_survey_message.button_name"
                      :survey-id="ticket.closed_with_survey_message.survey_id"
                      :survey-name="ticket.closed_with_survey_message.survey_name"
                      :created-at="ticket.closed_with_survey_message.created_at"
                      :updated-at="ticket.closed_with_survey_message.updated_at"
                      :is-default="ticket.closed_with_survey_message.is_default"
                      :expired-at="ticket.closed_with_survey_message.expire_survey_timestamp"
                      @click="handleSelectSurvey(index)"
                      @edit="(payload) => handleEditSurvey(payload, index)"
                    />
                  </v-flex>
                </template>
              </v-layout>
            </v-flex>
          </template>

          <v-flex
            xs12
            class="form-control px-1 pb-2"
            :class="{ 'has-error': errors.has('channel') }"
          >
            <div class="caption mb-1 mt-2">{{ $t('channel') }} *</div>

            <v-radio-group
              v-model="ticket.channel"
              v-validate="'required'"
              d-inline
              row
              :data-vv-as="$t('Channel')"
              name="channel"
            >
              <template v-for="channel in conversationSocialChannelOptions">
                <v-radio
                  :key="channel.fullValueForUse"
                  :label="channel.text"
                  :value="channel.fullValueForUse"
                  color="primary"
                  disabled
                ></v-radio>
              </template>
            </v-radio-group>
            <p v-if="errors.has('channel')" class="text-error">{{ errors.first('channel') }}</p>
          </v-flex>

          <v-flex xs12 class="mb-2">
            <div class="caption mb-1 mt-2">Wrap up</div>
            <WrapUpInput v-model="wrap_up_route" @onUpdate="handleUpdateWrapData" />
            <!-- <input
              v-model="ticket.wrap_up"
              v-validate="'required'"
              type="hidden"
              name="wrap_up"
              data-vv-as="Wrap up"
            /> -->

            <div class="form-control" :class="{ 'has-error': errors.has('wrap_up') }">
              <p v-if="errors.has('wrap_up')" class="text-error">{{ errors.first('wrap_up') }}</p>
            </div>
          </v-flex>

          <!-- <v-flex xs12>
            <div class="caption mb-1 mt-2">Tags</div>
            <v-combobox
              v-model="tags"
              :filter="tagsfilter"
              :hide-no-data="!tagssearch"
              :items="tagitems"
              :search-input.sync="tagssearch"
              hide-selected
              label="Search for an option"
              multiple
              small-chips
              outline
              single-line
            >
              <template #no-data>
                <v-list-tile>
                  <span class="subheading">Create</span>
                  <v-chip :color="`primary lighten-3`" label small>{{ tagssearch }}</v-chip>
                </v-list-tile>
              </template>
              <template #selection="{ item, parent, selected }">
                <v-chip
                  v-if="item === Object(item)"
                  :color="`primary lighten-3`"
                  :selected="selected"
                  label
                  small
                >
                  <span class="pr-2">{{ item.text }}</span>
                  <v-icon small @click="parent.selectItem(item)">close</v-icon>
                </v-chip>
              </template>
              <template #item="{ index, item }">
                <v-list-tile-content>
                  <v-text-field
                    v-if="tagediting === item"
                    v-model="tagediting.text"
                    autofocus
                    flat
                    background-color="transparent"
                    hide-details
                    solo
                    @keyup.enter="tagsedit(index, item)"
                  ></v-text-field>
                  <v-chip v-else :color="`primary lighten-3`" label small>{{ item.text }}</v-chip>
                </v-list-tile-content>
                <v-spacer></v-spacer>
                <v-list-tile-action @click.stop>
                  <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                    <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </template>
            </v-combobox>
          </v-flex> -->

          <v-flex xs12 class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('mood') }">
            <div class="caption mb-1 mt-2">{{ $t('mood') }}</div>

            <v-radio-group v-model="ticket.mood" d-inline row :data-vv-as="$t('mood')" name="mood">
              <template v-for="mood in moodOptions">
                <v-radio
                  :key="mood.value"
                  :label="`${handleGetMoodEmoji(mood.value)} ${mood.label}`"
                  :value="mood.value"
                  color="primary"
                ></v-radio>
              </template>
            </v-radio-group>
            <p v-if="errors.has('mood')" class="text-error">{{ errors.first('mood') }}</p>
          </v-flex>
          <v-flex class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('comment') }">
            <div class="caption mb-1 mt-2">{{ $t('comment') }}</div>
            <v-textarea
              v-model="ticket.comment"
              d-inline
              row
              class="default-input"
              :data-vv-as="$t('comment')"
              name="comment"
              box
              outline
              auto-grow
            ></v-textarea>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12 sm7 class="px-1 form-control">
            <div class="caption">Due Date</div>
            <datepicker
              v-model="duedate.start"
              color="primary"
              @selected="onSelectedDueDate"
            ></datepicker>
          </v-flex>
          <v-flex xs6 sm4 class="px-1 form-control">
            <div class="caption">Time</div>

            <v-dialog
              ref="starttime"
              v-model="showDueTimeDialog"
              :return-value.sync="duedate.starttime"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template #activator="{ on }">
                <v-layout>
                  <input
                    v-model="duedate.starttime"
                    type="text"
                    readonly
                    placeholder="00:00"
                    :disabled="duedate.start == null"
                    v-on="on"
                  />
                </v-layout>
              </template>
              <v-time-picker v-if="showDueTimeDialog" v-model="duedate.starttime" full-width>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="showDueTimeDialog = false">{{
                  $t('cancel')
                }}</v-btn>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    $refs.starttime.save(duedate.starttime)
                    showDueTimeDialog = false
                    onSelectedDueDate(duedate.end)
                  "
                  >{{ $t('Confirm') }}</v-btn
                >
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs2 sm1>
            <div class="caption">&nbsp;</div>
            <v-btn
              fab
              flat
              small
              @click="
                duedate.starttime = null
                duedate.start = null
              "
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <template
          v-if="selectedBot.ticket_v3_config && selectedBot.ticket_v3_config.enable_sale_type"
        >
          <v-divider class="my-3" />
          <SaleForm :key="saleFormTimestamp" ref="saleForm" v-model="saleForm" />
        </template>

        <ToggleAdvance>
          <div>
            <div class="mt-4 mb-3">
              <div class="caption primary--text">First reply time from the Last Admin</div>
              <div>{{ ticket.adminfirstresponsetime | DateFormat('DD/MM/YYYY HH:mm') }}</div>
            </div>

            <div class="mb-3">
              <div class="caption primary--text">Last Assign Ticket Time</div>
              <div>{{ ticket.assign_ticket_timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</div>
            </div>

            <div class="mb-3">
              <div class="caption primary--text">First reply time from the first admin</div>
              <div>
                {{
                  (ticket.first_admin_first_response_time || ticket.adminfirstresponsetime)
                    | DateFormat('DD/MM/YYYY HH:mm')
                }}
              </div>
            </div>

            <div class="mb-3">
              <div class="caption primary--text">Assign Ticket First After Creation</div>
              <div>{{ ticket.first_assign_ticket_timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</div>
            </div>

            <div class="mb-3">
              <div class="caption primary--text">Last admin reply</div>
              <div>{{ ticket.last_admin_reply | DateFormat('DD/MM/YYYY HH:mm') }}</div>
            </div>

            <div class="mb-3">
              <div class="caption primary--text">Last update</div>
              <div>{{ ticket.updateadminid }}</div>
            </div>

            <div class="mb-3">
              <div class="caption primary--text">Last update date</div>
              <div>{{ ticket.adminupdatetime | DateFormat('DD/MM/YYYY HH:mm') }}</div>
            </div>
          </div>
        </ToggleAdvance>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="!hideEditButton">
          <v-btn outline color="grey" :loading="loading || loadingTicket" @click="onCancel">
            {{ $t('cancel') }}
          </v-btn>
        </template>

        <v-btn color="primary" depressed :loading="loading || loadingTicket" @click="onSave">{{
          $t('Save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import TicketEdit from './TicketEdit.js'
import CopyButtonVue from '@/components/elements/CopyButton.vue'
import ToggleAdvance from '@/components/elements/ToggleAdvance.vue'
import SaleForm from './SaleForm.vue'
import SurveyCard from './CustomerSupportService/SurveyCard.vue'
import { isEqual } from 'lodash'
import { FEATURE } from '@/constants/feature.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    CopyButtonVue,
    ToggleAdvance,
    SaleForm,
    SurveyCard
  },
  mixins: [TicketEdit],
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.$validator.pause()
    this.$nextTick(() => {
      this.$validator.errors.clear()
      this.$validator.fields.items.forEach((field) => field.reset())
      this.$validator.fields.items.forEach((field) => this.errors.remove(field))
      this.$validator.resume()
    })
  },
  methods: {
    handleCheckEqual(survey, surveySelected) {
      if (survey && surveySelected) {
        return isEqual(survey, surveySelected)
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketEdit.vue